import React from 'react';
import { Alert, Table }  from 'reactstrap';
import * as Icon from 'react-feather';
import { ConfirmModal } from '../Modals/Confirm';

export function ConfirmDeleteMessageTemplateModal(props) {
    return (
        <ConfirmModal 
            isOpen={props.isOpen}
            toggle={props.toggle} 
            handleConfirm={(e) => props.handleConfirm(props.messageTemplate, e)}
            title="Delete Message Template?"
            confirmText="Yes, Delete Message Template"
            confirmColor="danger"
            confirmIcon={Icon.Trash2}
        >
            <Alert color="warning">
                <strong>Are you sure you wish to delete the following Message Template?</strong>
            </Alert>

            <Table bordered>
                <thead>
                    <tr>
                        <th className="col-xs-6">Name</th>     
                        <th className="col-xs-6">Description</th>                  
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{props.messageTemplate.name}</td>
                        <td>{props.messageTemplate.description}</td>
                    </tr>
                </tbody>
            </Table>
        </ConfirmModal>
    );
}